import { ClientsStatusReport } from 'components/Report';
import { endpoints } from 'api';

function NewUnverifiedClientsPage() {
    return (
        <ClientsStatusReport APIEndpoint={endpoints.NEW_UNVERIFIED_CLIENTS_REPORT} ReportName='New Unverified Clients' />
    );
}
export default NewUnverifiedClientsPage;
